import type { BrindeFornecedor } from "../models/brindesFornecedorModel"

export enum BrindesFornecedorActionsTypes {
    CARREGAR = "CARREGAR",
}

type CarregarAction = {
    type: BrindesFornecedorActionsTypes.CARREGAR
    payload: BrindeFornecedor[]
}

export type BrindesFornecedorActions = CarregarAction
